import { Injectable } from '@angular/core';
import { STATUS_ERROR, STATUS_SUCCESS } from '@df/core/status';
import { NOTICES } from '@df/ui/api/notice/notice.const';

@Injectable({
    providedIn: 'root'
})
export class NoticeService {
    transform(input: string | number, successMsg?: string): string | undefined {
        if (typeof input === 'number') {
            if (NOTICES[input]) {
                return NOTICES[input];
            } else {
                input = STATUS_ERROR;
            }
        }
        
        if (typeof input !== 'string') {
            return input;
        }

        if (input === STATUS_SUCCESS) {
            return successMsg;
        }

        return NOTICES[input] || input;
    }
}
